<template>
  <div>
    <b-card-body class="pt-0">
      <b-row class="d-flex flex-column flex-md-row align-items-center">
        <b-col cols="12" md="4" class="mb-2 mb-md-0">
          <div class="font-medium-1">Total Earnings</div>
          <!-- {{ earningsChart.chartOptions.labels }} -->
          <h5 class="mb-1">₹{{ totalEarnings.toLocaleString("en-IN") }}</h5>

          <div v-for="(service, index) in earningsChart.series" :key="index">
            <h5 class="font-small-2 pro_text">
              {{ service.name }}
            </h5>
            <h5>₹{{ service.value.toLocaleString("en-IN") }}</h5>
          </div>
        </b-col>
        <b-col cols="12" md="8" style="min-height: 250px">
          <!-- chart -->
          <vue-apex-charts
            type="donut"
            height="250"
            :options="earningsChart.chartOptions"
            :series="earningsChart.series"
            v-if="showChart"
            @error="handleChartError"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </div>
</template>

<script>
import CommonServices from "@/apiServices/CommonServices";
import store from "@/store";
import {
  BCard,
  BRow,
  BCol,
  BCardTitle,
  BCardText,
  BCardBody,
  BCardHeader,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardTitle,
    BCardText,
    VueApexCharts,
    BCardBody,
    BCardHeader,
  },

  data() {
    return {
      totalEarnings: 0, // Dummy data
      showChart: false,
      earningsChart: {
        series: [], // Dummy data
        chartOptions: {
          chart: {
            type: "donut",
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: true,
          },
          legend: {
            show: true,
            position: "right",
            horizontalAlign: "center",
            fontSize: "12px",
            labels: {
              colors: ["#333"],
            },
            markers: {
              width: 12,
              height: 12,
              radius: 6,
            },
          },
          comparedResult: [2, -3],
          labels: [],
          stroke: { width: 0 },
          colors: ["#2bccbc", "#2fdba9"],
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              startAngle: -10,

              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter: function (w) {
                      const total = w.globals.seriesTotals.reduce(
                        (a, b) => a + b,
                        0
                      );
                      return `₹${total.toLocaleString("en-IN")}`;
                    },
                  },
                  total: {
                    show: true,
                    offsetY: 15,
                    label: "Total",
                    formatter: () =>
                      `₹${this.totalEarnings.toLocaleString("en-IN")}`,
                  },
                },
              },
            },
          },
          // responsive: [
          //   {
          //     breakpoint: 1325,
          //     options: {
          //       chart: {
          //         width: 400,
          //       },
          //     },
          //   },
          //   {
          //     breakpoint: 1200,
          //     options: {
          //       chart: {
          //         width: 300,
          //       },
          //     },
          //   },
          //   {
          //     breakpoint: 992,
          //     options: {
          //       chart: {
          //         width: 250,
          //       },
          //     },
          //   },
          //   {
          //     breakpoint: 768,
          //     options: {
          //       chart: {
          //         width: 200,
          //       },
          //     },
          //   },
          // ],
        },
      },
    };
  },
  props: {
    service_id: {
      type: Number,
      default: 8,
    },
    package_bifurcation: Boolean,
  },
  computed: {
    franchise_id() {
      return store.getters["user/getUserDetails"].user_id;
    },
  },
  watch: {
    service_id() {
      this.getRevenueById(this.franchise_id, this.service_id);
    },
  },

  methods: {
    async getRevenueById(franchise_id, service_id) {
      try {
        this.showChart = false;
        const payload = {
          franchise_id: franchise_id,
          service_id: service_id || 8,
        };
        const res = await CommonServices.getServiceRevenueById(payload);

        if (res.data.status) {
          // const serviceData = res.data.data.service_data || [];
          const serviceData = [
            {
              plan_name: "Aliff Basic",
              plan_id: 50,
              commission: 25000,
              package: "Aliff Basic",
            },
            {
              plan_name: "Aliff Pro",
              plan_id: 47,
              commission: 95000,
              package: "Aliff Pro",
            },
          ];
          const servicePlans = res.data.data.service_plans || [];

          this.earningsChart.series = serviceData.map((service) => ({
            value: service.commission || 0,
            name: service.plan_name,
            id: service.plan_id,
          }));
          this.earningsChart.chartOptions.labels = serviceData.map(
            (service) => service.plan_name
          );

          this.totalEarnings = serviceData.reduce(
            (total, service) => total + (service.commission || 0),
            0
          );
          this.earningsChart = { ...this.earningsChart };

          this.$nextTick(() => {
            this.showChart = true;
          });
        }
      } catch (error) {
        console.error("Error fetching service revenue:", error);
      }
    },
    handleChartError(e) {
      console.error("Chart error:", e);
    },
  },

  beforeMount() {
    if (this.franchise_id) {
      this.getRevenueById(this.franchise_id, this.service_id);
    }
  },
};
</script>
<style scoped>
.package_text {
  color: #34c759;
  font-weight: 600;
}

.service_text {
  color: #ff9500;
  font-weight: 600;
}

.filter_text {
  font-size: small;
  font-weight: 700;
  opacity: 0.7;
  margin-left: 5px;
  padding-bottom: 2px;
}
</style>
